import { render, staticRenderFns } from "./TwoFactorAuthDisableConfirmation.vue?vue&type=template&id=0f6b11ab&scoped=true"
import script from "./TwoFactorAuthDisableConfirmation.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthDisableConfirmation.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthDisableConfirmation.vue?vue&type=style&index=0&id=0f6b11ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b11ab",
  null
  
)

export default component.exports